import { render } from "./TicketAssociation.vue?vue&type=template&id=497c60f8"
import script from "./TicketAssociation.vue?vue&type=script&lang=js"
export * from "./TicketAssociation.vue?vue&type=script&lang=js"

import "./TicketAssociation.vue?vue&type=style&index=0&id=497c60f8&lang=scss"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__